module.exports = __webpack_public_path__ + "img/103071-upgrade-to-premium.42ff4b7.gif";